import React, { useState } from 'react';
import JuchuShokai from '../../appForms/JuchuShokai/JuchuShokaiMain';
import { Link, useParams } from 'react-router-dom';
import Header from '../../common/compornents/layout/header/Header';
import { Footer } from 'antd/lib/layout/layout';
import { Button, Col, Row, Spin } from 'antd';

const JuchuShokaiComponent: React.FC = () => {
  const { yobidashimotoKbn } = useParams<{ yobidashimotoKbn: string }>();
  // インジケーター表示フラグ
  const [loading, changeLoading] = useState<boolean>(false);

  // JSX
  return (
    <>
      <Spin spinning={loading}>
        <Header screenName={'注文一覧'} showLogout={true} />
        <JuchuShokai
          yobidashimotoKbn={yobidashimotoKbn}
          loading={loading}
          changeLoading={changeLoading}
        />
        <Footer
          style={{
            backgroundColor: '#e6f7ff',
            height: '148px',
          }}
        >
          <Row>
            <Col offset={22}>
              <Link to="/login">
                <Button size={'large'} type="primary">
                  終了
                </Button>
              </Link>
            </Col>
          </Row>
        </Footer>
      </Spin>
    </>
  );
};
export default JuchuShokaiComponent;
